import React from 'react';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import constants from 'lib/constants';
import Select from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;

// EXPORTED COMPONENT
// ================================================================
const StatesInput = props => {
  const { onChange, value } = props;

  const optionsChildren = constants.statesData.map(({ abbreviation }) => (
    <Option key={abbreviation} value={abbreviation}>
      {abbreviation}
    </Option>
  ));
  return (
    <Select
      size="large"
      onChange={onChange}
      value={value}
      showSearch
      optionFilterProp="children"
      filterOption={GeneralHelpers.selectSearchFilter}
    >
      {optionsChildren}
    </Select>
  );
};

// EXPORT
// ================================================================
export default StatesInput;



// WEBPACK FOOTER //
// ./src/components/inputs/StatesInput/index.js